import { observer } from 'mobx-react';
import { Button, Flex, Link, Text } from '@servicetitan/anvil2';

import * as styles from './welcome.module.less';

export interface WelcomeScreenProps {
  onConfirmHeadsUpBanner?: () => void;
}

export const WelcomeScreen = observer(
  ({ onConfirmHeadsUpBanner }: WelcomeScreenProps) => {
    const handleContinue = () => {
      onConfirmHeadsUpBanner?.();
    };

    return (
      <Flex
        id='ManagerAssistChat-WelcomeScreen-Container'
        direction='column'
        className={styles.welcomeRoot}
      >
        <Flex className={styles.welcome}>
          <div className={styles.illustration} />
        </Flex>
        <Flex direction='column'>
          <Flex direction='column' className='p-inline-3 p-block-4'>
            <Text
              id='ManagerAssistChat-WelcomeScreen-Title'
              variant='headline'
              el='h1'
            >
              Hi there!
            </Text>
            <Text
              id='ManagerAssistChat-WelcomeScreen-Description'
              size='medium'
            >
              <b>Just a quick heads-up before we begin:</b>
            </Text>
            <Text>
              I'm your AI assistant, here to help you find answers faster and
              make your experience smoother. I'll do my best to provide helpful,
              accurate info - but it may not always be error-free, and it's not
              a substitute for professional or legal advice when it really
              counts.
            </Text>
            <br />
            <Text>
              By continuing, you acknowledge that any data collected will be
              used in accordance with our{' '}
              <Link
                href='https://www.servicetitan.com/legal/privacy-policy'
                appearance='secondary'
              >
                Privacy Policy
              </Link>
              , and may be shared with third-party service providers. You also
              agree to use this feature responsibly and understand that your
              input may help us improve the experience over time.
            </Text>

            <br />
          </Flex>
          <Flex justifyContent='center'>
            <Button
              id='ManagerAssistChat-WelcomeScreen-GetStartedButton'
              appearance='primary'
              size='medium'
              onClick={handleContinue}
            >
              Let's Get Started
            </Button>
          </Flex>
        </Flex>
      </Flex>
    );
  },
);
